export function setSettlement(state, settlement) {
  state.settlement = { ...settlement };
}

export function setState(state, [field, value]) {
  state[field] = value;
}
